var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"endTime":_vm.endTime,"callback":_vm.callback,"endText":_vm.endText}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.content)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }